module.exports = __webpack_public_path__ + "static/media/12@2x.6ca501b6.png";